// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__30rLq","insightsList":"newBusinessInsightsMenu_insightsList__2IAiP","active":"newBusinessInsightsMenu_active__1Mbyp"};